module.exports = __webpack_public_path__ + "img/cloudy-day.13019c1f.png";